
// import { ScrollSpy } from "./classes/scroll_spy"
import { ScrollSpy } from "./classes/utils/scroll_spy"
import Form, { initFormField } from "./classes/form/form"
import ToggleableText from './classes/utils/toggleable_text'
import Toggler from './classes/utils/toggler'
import DropdownSpoiler from './classes/utils/dropdown_spoiler'
import Modal from './classes/utils/modal'
import { TooltipHandler } from './classes/utils/tooltip_handler'
import { FocusHandler } from "./classes/focus_handlers";

import Inputmask from "inputmask";

import './main.css'

import { initLazySwiperTournament } from "./snippets/init/lazy-swiper-tournament"
import { ScrollAnchorsHandler } from "./classes/scroll_anchors_handler"


import { init as initSearchAdminsReactForm } from "./snippets/init/search-admins-react-form"
import { init as initTournamentForm } from "./snippets/init/tournament-form"
import { Dispatcher } from "./classes/simple_dispatcher"
import Accordion from "./classes/utils/accordion"
import { transform } from "motion/react"
// import DateField from './classes/fields/date'
// import TextField from './classes/fields/text'
// import PasswordField from './classes/fields/password'
// import EmailField from './classes/fields/email'

import {animateDonateBanner} from './snippets/init/donate-banner'


const $ = window.jQuery


ScrollSpy
    .getInstance()
    .registerTarget(
        document.querySelector('.top-header__wrapper'),
        // {
        //     anchors: {
        //         'screen_inner': [
        //             'left', 'top', 'right',
        //         ]
        //     }
        // }
    );


$(document).click(function(){
    FocusHandler.Focus(null)
})
$(document).on( "keydown", function(event) {
    if(event.code == 'Escape'){
        FocusHandler.Focus(null)
    }
});

$(document).ready(function () {
    initBurgerButton();
    initDartAnimation();
    initForms();
    initMobileMenuPopups(); 
    initMisc();
    initModals();
    initInputMasks();
    initLazySwiperTournament($);
    initStickyTables($);
    initStickySidebar($);
    initScrollAnchors($);
    initScrollObserver($);
    initAccordions($);
    initExternalDownloads($);
    // initSelectSearch($);

    const tournament_form_app = document.getElementById('tournament_form_app')
    if(tournament_form_app){
        initTournamentForm({
            root: tournament_form_app
        });
    }


    const react_list_form = document.getElementById('react_list_form')
    if(react_list_form){
        initSearchAdminsReactForm({
            root: react_list_form,
            csrf_token: $(react_list_form).data('csrf-token'),
            search_select_id: $(react_list_form).data('search-select-id'),
            urls: {
                search: $(react_list_form).data('url-search'),
                // get_list: $(react_list_form).data('url-get-list'),
                list: $(react_list_form).data('url-list'),
                add_item: $(react_list_form).data('url-add-item'),
                remove_item: $(react_list_form).data('url-remove-item'),
            }
        });
    }

    // $('.js-download-external').each(function(){
    //     downloadExternal(this.href)
    // })    
    // $('.button[data-modal="league_edit_admins"]').trigger('click')
    $(document).trigger('main:inited')
});

$(window).resize(function(){
    initDartAnimation();
    initMobileMenuPopups();
    initStickyTables($);
});

function initExternalDownloads(){
    $('.js-download-external').click(function(event){
        event.preventDefault()
        event.stopPropagation()
        const href = this.href
        const name = this.download
        if(href){
            downloadExternal(href, name)
        }
    })
}

function initAccordions($){
    $('.js-accordion').each(function(){    
        new Accordion(this, {
            close_prev_item: true,
        });
    })
}

function downloadExternal(url, filename){
    if(!filename){
        filename = url.substring(url.lastIndexOf("/") + 1).split("?")[0];
    }
    const xhr = new XMLHttpRequest();
    xhr.responseType = 'blob';
    xhr.onload = function() {
        const a = document.createElement('a');
        const url = URL.createObjectURL(xhr.response);
        a.href = url
        a.download = filename
        a.style.display = 'none'
        document.body.appendChild(a)
        a.click()
        a.remove()
        URL.revokeObjectURL(url);
    };
    xhr.open('GET', url);
    xhr.send();
}


function initInputMasks(){
    $('input[name="phone"]').each(function(){
        Inputmask("+7(999)999-99-99").mask(this);
    })

    $('.social-fields [name="vk"]').each(function(){
        $(this).attr('placeholder', 'https://vk.com/id')
        Inputmask("https://vk.com/*{2,}", {
            greedy: false,
        }).mask(this);
    })

    $('.social-fields [name="telegram"]').each(function(){
        $(this).attr('placeholder', 'https://t.me/@')
        Inputmask("https://t.me/@*{2,}", {
            greedy: false,
        }).mask(this);  
    })

    $('.social-fields [name="youtube"]').each(function(){
        $(this).attr('placeholder', 'https://youtube.com/@')
        Inputmask("https://youtube.com/@*{2,}", {
            greedy: false,
        }).mask(this);
    })
}

function initModals(){

    FocusHandler.InitInstance('modals')
    // FocusHandler.InitInstance('menus')
    const modals_store = {}
    $('.modal:not(.-react)').each(function(){
        const modal = new Modal(this)
        // modal.toggle(true)
        const modal_key = $(this).attr('data-modal')
        modals_store[modal_key] = modal
    });

    $('.js-modal-invoker').each(function(){
        const modal_key = $(this).attr('data-modal')
        if(modal_key in modals_store){
            const modal = modals_store[modal_key]
            $(this).click(modal.toggle.bind(modal, true))
        }
    })
}

function initMisc(){
    $('.js-toggleable-text').each(function(){
        new ToggleableText(this);
    })
    $('.tooltip').each(function(){
        new TooltipHandler(this)
    })
    $('.js-back-btn').each(function(){
        $(this).click(function(){
            window.history.back()
        })
    })
    $('.js-simple-bind').each(function(){
        const bind_id = $(this).attr('data-bind-id')
        const css_class = $(this).attr('data-bind-class')
        const event_on = $(this).attr('data-bind-event-on')
        const event_off = $(this).attr('data-bind-event-off')
        this.addEventListener(event_on, function(){
            $(`[data-bind-id="${bind_id}"]`).addClass(css_class)
        })
        this.addEventListener(event_off, function(){
            $(`[data-bind-id="${bind_id}"]`).removeClass(css_class)
        })
    })

    

    $('.js-dropdown-spoiler').each(function(){
        const dropdown_spoiler = new DropdownSpoiler(this)
        Dispatcher.registerByKey(
            dropdown_spoiler.id,
            dropdown_spoiler
        )
    })

    $('.js-toggler').each(function(){
        const toggler = new Toggler(this)
        toggler.addEventListener('toggled', function(args){
            const ids = toggler.id.split('|')
            for(const id of ids){
                Dispatcher.dispatchByKey(id, 'onToggled', args)
            }
        })
    })
}

function initStickyTables($){
    $('.js-lazy-sticky').each(function(){
        $(this).find('.js-lazy-sticky__row').each(function(){
            let left = 0;
            const $cells = $(this).find('.js-lazy-sticky__cell')
            $cells.each(function(index){
                $(this).css({
                    left: `${left}px`,
                })
                $(this).addClass('-sticky')

                if(index == $cells.length-1){
                    $(this).addClass('-last-sticky')
                }

                left += $(this).outerWidth()
            })
        })
    })
}

// class Sticky

function initStickySidebar($){

    window.addEventListener('scroll', function(){

    })

    $('.js-sticky-sidebar').each(function(){
        const margin = Number($(this).attr('data-offset')) || 0;
        // let top = $('.top-header').height() + margin;
        // $(this).css({
        //     top: `${top}px`
        // })
        ScrollSpy
            .getInstance()
            .registerTarget(
                this,
                {
                    target_type: 'sidebar',
                    offset: {
                        top: () => {
                            return $('.top-header').height() + margin
                        }
                    },
                    // container: $(this).parent()[0]
                }
            )
    })
    $('.js-sticky-element').each(function(){
        const margin = Number($(this).attr('data-offset')) || 0;
        let top = $('.top-header').height() + margin;
        $(this).css({
            top: `${top}px`
        })
    })
}

function initScrollAnchors($){    
    const q_anchors = $('.js-scroll-anchor')
    if(q_anchors.length > 0){
        ScrollAnchorsHandler
            .getInstance({
                offset_callback: function(){
                    let offset = $('.top-header').height() + 50

                    if(window.innerWidth < 980){
                        offset += $('.js-form-anchor-select').height() + 20
                    }

                    return offset
                }
            })
            .append(q_anchors.toArray())
        ScrollAnchorsHandler
            .getInstance()
            .handleScroll()
    }

    $('.js-form-anchor-select').each(function(){
        const dom_field = $(this).find('.js-form-field')[0]
        let field = initFormField(dom_field)

        for(const value of field.getOptions()){
            const anchor = ScrollAnchorsHandler
                    .getInstance()
                    .findAnchorById(value);
    
            anchor.addEventListener('toggle', function(event){
                if(event.value){
                    field.setValue(event.sender.getId())
                }
            })
        }

        field.addEventListener('changed', function(){
            ScrollAnchorsHandler
                .getInstance()
                .scrollById(this.getValue())
        }.bind(field))
    })
}



function initScrollObserver($){
    const main_observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.dispatchEvent(new Event('viewenter'))
            } else {
                entry.target.dispatchEvent(new Event('viewleave'))
            }
        });
    }, {
        root: null,
        threshold: 0.5
    });

    $('.ad-banner').on('viewenter', function(){
        $(this).addClass('-appear-triggered')
    })
    $('.ad-banner').on('viewleave', function(){
        if($(this).hasClass('-appear-triggered')){
            main_observer.unobserve(this)
        }
    })
    $('.ad-banner').each(function(){
        main_observer.observe(this)
    })

    $('.donate-banner').each(function(){
        main_observer.observe(this)
    })
    $('.donate-banner').on('viewenter', function(){
        animateDonateBanner();        
    })
    $('.donate-banner').on('viewleave', function(){
        if($(this).hasClass('-triggered')){
            main_observer.unobserve(this)
        }
    })
}

function initMobileMenuPopups(){
    const $popups = $('.top-header__mobile-popup, .top-header .tooltip-popper')
    if(window.innerWidth < 980){
        const height = $('.top-header__wrapper').height()
        $popups.css({
            top: `${height}px`,
            height: `calc(100vh - ${height}px)`,
        })
    }else{
        $popups.attr('style', '')
    }
}

function initForms(){
    $('.js-form').each(function(){
        new Form(this)
    })

    $('.js-form-filter-select').each(function(){
        const dom_field = $(this).find('.js-form-field')[0]
        let field = initFormField(dom_field) 
        const that = this
        field.addEventListener('changed', function(){
            $(that).trigger('submit')
        }.bind(field))
        $(this).submit(function(event){
            event.stopPropagation()
            event.preventDefault()
            const key = field.dom.select.value
            let href
            console.log(this)
            if(key){
                const format = $(this).attr('data-href-format')
                href = format.replace('%key%', key)
            }else{
                href = $(this).attr('data-href-none')
            }
            window.location.href = href
        })
    })
}

function initBurgerButton(){

    const button = $('#header_burger')?.[0]

    function __do(){
        const is_open = $(this).hasClass('is--open');

        console.log(this, is_open);

        if(is_open){
            FocusHandler.Focus(this) 
        }

        $('.logo.header-logo').toggleClass('is--target', is_open);
        $('.top-header__mobile-popup').toggleClass('is--open', is_open);
        initDartAnimation();
    }

    if(button){
        button.unfocus = function(){
            console.trace('unfocus')
            $(this).toggleClass('is--open', false);
            __do.call(this)
        }.bind(button)

        $(button).click(function(event){
            event.stopPropagation()
            $(this).toggleClass('is--open');
            __do.call(this)
            // FocusHandler.Focus(this)
        });
    }
    localStorage.setItem('darts_animation_runs_count', 0);
}

function initDartAnimation(){
    const $logo = $('.logo.header-logo');
    const $burger = $('#header_burger');
    let target_x = $logo.offset().left + $logo.width() / 2 - $burger.offset().left;
    let target_y = 1.5;
    let angle = 0;
    let runs_count = Number(localStorage.getItem('darts_animation_runs_count'));
    if(runs_count > 3){
        target_x += (-15 + Math.random() * 15);
        target_y += (-5 + Math.random() * 5);
        angle = (-7 + Math.random() * 7);
    }
    $('.button-burger__line-bolid').css({
        transform: `translate(${target_x}px, ${target_y}px) rotate(${angle}deg)`,
        // transitionDuration: `${window.innerWidth/1800}s`,
        transitionDuration: `0.2s`,
    });
    runs_count++;
    localStorage.setItem('darts_animation_runs_count', runs_count);
}
    